// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__iB81z","textarea":"styles_textarea__18UIu"};